module.exports = __webpack_public_path__ + "img/icon-watch.238910b1.svg";